module.exports = __webpack_public_path__ + "img/trip(17).9523c5ec.webp";